import { calculateAge, calculateAgeInWeeks } from './calculateAge'

/**
 * Retorna uma representação textual da idade de uma pessoa, no
 * formato 'XX anos e XX meses' para idades maiores que 1 ano
 * e 'XX meses e XX dias' para idades menores que um ano.
 *
 * @param dataNascimento A data de nascimento da pessoa
 * @param refDate A data de referência para calcular a idade
 */
export function humanizeAge(dataNascimento: string, refDate: string | number = Date.now()) {
  const { years, months, days } = calculateAge(dataNascimento, refDate)

  if (years === 0 && months === 0 && days === 0) {
    return 'Recém nascido'
  } else if (years < 1 && months < 1) {
    return `${days} ${days === 1 ? 'dia' : 'dias'}`
  } else if (years < 1) {
    return `${months} ${months === 1 ? 'mês' : 'meses'}${days > 0 ? ` e ${days} ${days === 1 ? 'dia' : 'dias'}` : ''}`
  } else if (years >= 1 && months === 0) {
    return `${years} ${years === 1 ? 'ano' : 'anos'}`
  } else {
    return `${years} ${years === 1 ? 'ano' : 'anos'} e ${months} ${months === 1 ? 'mês' : 'meses'}`
  }
}

/**
 * Retorna uma descrição da idade baseada no cálculo em semanas da função `calculateAgeInWeeks`.
 *
 * @param dataNascimento A data de nascimento da pessoa
 * @param referenceDate A data de referência para calcular a idade
 * @returns `Recém nascido` caso não tenha completado 1 semana entre as datas; `1 semana`, quando tiver 1 semana;
 * ou `x semanas`, onde `x` é a idade em semanas, truncado no número de dias.
 */
export function humanizeAgeInWeeks(dataNascimento: string, referenceDate: string | number = Date.now()): string {
  const weeks = calculateAgeInWeeks(dataNascimento, referenceDate)
  if (weeks < 1) return 'Recém nascido'

  return `${weeks} ${weeks === 1 ? 'semana' : 'semanas'}`
}
